export default __webpack_public_path__ + "static/media/sv5_kr_head_a1.432c7780.mp3";